export default __webpack_public_path__ + "static/romaric-philogene-bc0408783aeeabfe7bb239b9b6df7876.png";